import { render, staticRenderFns } from "./employeeassets.vue?vue&type=template&id=20697471&"
import script from "./employeeassets.vue?vue&type=script&lang=js&"
export * from "./employeeassets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports